export var StyleParamType;
(function (StyleParamType) {
    StyleParamType["Number"] = "Number";
    StyleParamType["Boolean"] = "Boolean";
    StyleParamType["Font"] = "Font";
    StyleParamType["Color"] = "Color";
    StyleParamType["String"] = "String";
})(StyleParamType || (StyleParamType = {}));
//# sourceMappingURL=StylesContext.types.js.map